import { setUserDataCriticalActionCodeListener } from '@wildberries/databus-service-user';

export const getUserDataCriticalActionCode = async (): Promise<number> => {
  return new Promise((resolve) => {
    setUserDataCriticalActionCodeListener(({ criticalActionCode }) => {
      if (criticalActionCode) {
        resolve(criticalActionCode);
      }
    });
  });
};
